module.exports = __webpack_public_path__ + "static/media/item-dimension.3f552edc.jpg";